import React from 'react';
import Modal from '../../../shared/components/ui/Modal';
import Button from '../../../shared/components/ui/Button';

interface UploadTacticsPromptProps {
  isOpen: boolean;
  isUploading: boolean;
  onClose: () => void;
  onUpload: () => void;
}

const UploadTacticsPrompt: React.FC<UploadTacticsPromptProps> = ({
  isOpen,
  isUploading,
  onClose,
  onUpload,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Upload to Cloud?" className="max-w-md">
      <div className="p-6 space-y-4">
        <p className="text-sm text-gray-700">
          Your tactics configuration has been saved. Would you like to generate and upload an image to the cloud now?
        </p>
        <p className="text-xs text-gray-500">
          You can upload it later from the saved configurations list if you prefer.
        </p>

        <div className="flex justify-end space-x-3 pt-4">
          <Button type="button" variant="ghost" onClick={onClose} disabled={isUploading}>
            Cancel
          </Button>
          <Button type="button" variant="primary" onClick={onUpload} disabled={isUploading}>
            {isUploading ? 'Uploading…' : 'Upload'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadTacticsPrompt;

